import { Bar, mixins } from 'vue-chartjs'
import { defaultConfig } from 'vuestic-ui/src/components/vuestic-components/va-chart/VaChartConfigs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
export default {
  extends: Bar,
  mixins: [
    mixins.reactiveProp
  ],
  props: [
    'chartData',
    'options'
  ],
  data () {
    return {
      chart: null,
      customPlugin: {
        beforeInit: chartInstance => {
          this.chart = chartInstance
          this.$emit('chart-init', { chart: chartInstance })
        }
      }
    }
  },
  mounted () {
    this.addPlugins()
      .then(() => this.refresh())
  },
  methods: {
    addPlugins: function () {
      this.addPlugin(this.customPlugin)
      this.addPlugin(ChartDataLabels)
      return Promise.resolve()
    },
    refresh: function () {
      if (this.chart) {
        this.chart.destroy()
      }
      this.renderChart(this.chartData, this.graphOptions)
    }
  },
  computed: {
    graphOptions: function () {
      return Object.assign({}, defaultConfig, this.options)
    }
  },
  watch: {
    graphOptions: function () {
      this.refresh()
    }
  }
}
